import { createActions } from "redux-actions";

export const APP_ACTION = "APP_ACTION";
export const SET_ERROR = "SET_ERROR";

const actionsCreator = createActions({}, ...[APP_ACTION, SET_ERROR]);
export const { appAction, setError } = actionsCreator;
